module.exports = __webpack_public_path__ + "assets/media/day25.277cc2ca.mp3";